import React, {Component} from 'react'
import axios from "axios";

class Uploader extends Component {
    validate = (fileItems, fileEntity, dependencies) => {
        return new Promise((resolve, reject) => {
            var matches = 0;
            fileItems.forEach(function(uploadedFile) {
                if (uploadedFile.size === fileEntity.size &&
                    uploadedFile.originalName === fileEntity.originalName
                ) {
                    matches++;
                }
            });
            if (matches > 0) {
                reject('File uploaded already');
            }
            else if (fileEntity.size === dependencies.sizeMin){
                reject('File is empty');
            }
            else if (fileEntity.extension === '') {
                reject('File Format is empty');
            }
            else if (!dependencies.allowedMediaExtensions.includes(fileEntity.extension)) {
                reject('Unsupported Format File');
            }
            else {
                resolve();
            }
        })
    };

    save = (fileEntity, type) => {
        return axios.post('/api/file/save', {
            'extension': fileEntity.extension,
            'originalName': fileEntity.originalName,
            'size': fileEntity.size,
            'mime': fileEntity.mime,
            'duration': fileEntity.duration,
            'source': fileEntity.source,
            'path': fileEntity.path,
            'type': type,
        }).then(res => {
            return res.data;
        });
    };

    getMediaInfo = fileEntity => {
        return axios.get('/api/file/media-info?url='+fileEntity.source).then(res => {
            if (res.data.duration <= 0) {
                throw 'Can not get audio duration';
            }

            return res.data;
        })
    };
}

export default Uploader